import { render, staticRenderFns } from "./PatientProgress.vue?vue&type=template&id=71efddb7&scoped=true&"
import script from "./PatientProgress.vue?vue&type=script&lang=js&"
export * from "./PatientProgress.vue?vue&type=script&lang=js&"
import style0 from "./PatientProgress.vue?vue&type=style&index=0&id=71efddb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efddb7",
  null
  
)

export default component.exports